import { Component } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router"

import { ControlesService } from '@app/_services/controles.service';

import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService, UsuariosService } from '../_services';

@Component({
  selector: 'app-controles',
  templateUrl: 'controles.component.html'
})

export class ControlesComponent {

  public seleccionados: number[] = [];
  private translate: TranslateService;
  public controles: [];
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;
  closeResult = '';
  navigationSubscription;
  user = this.userService.userValue;

  constructor(private controlesService: ControlesService,
    translate: TranslateService,
    public router: Router,
    private menuService: MenuService,
    private userService: UsuariosService,
    private modalService: NgbModal) {

    this.translate = translate;
   

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/controles') {
          this.menuService.titulo = this.translate.instant('controles').toUpperCase();
          this.controlesService.GetAll().subscribe((result) => {
            this.controles = result.data;
          }
          );
        } else {
        }
      }
    });
  }

  ngOnInit() {
    this.controlesService.GetAll().subscribe((result) => {
        this.controles = result.data;
      }
    );
  }

  onClickNuevo() {
    this.router.navigate(['controles/crear/']);
  }

  onClickEditar() {
    if (this.seleccionados[0] > 0) {
      this.router.navigate(['controles/editar/', this.seleccionados[0]]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['controles/editar/', this.seleccionados[0]]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading, contentNotErased) {
    this.controlesService.delete({ ids: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.controlesService.GetAll().subscribe((result) => {
              this.controles = result.data;
            }
          );
        }
        this.modalReferenceloading.close();
      }
    );

    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }
}
